module.exports = __webpack_public_path__ + "static/media/294877.588f3416.png";